import React, { useState } from "react";
import { useSenderProfile } from "../lib/senderProfile";
import { User, EnvelopeSimple, CurrencyEur, CaretDown, CaretUp } from "@phosphor-icons/react";

export const SenderProfileCard = () => {
  const [profile, save] = useSenderProfile();
  const [open, setOpen] = useState(!profile.name);
  const [form, setForm] = useState({
    name: profile.name || "",
    email: profile.email || "",
    price_per_lead: profile.price_per_lead || "2",
    company: profile.company || "",
  });

  const submit = (e) => {
    e.preventDefault();
    save(form);
    setOpen(false);
  };

  const complete = profile.name && profile.email;

  return (
    <div className="border border-black bg-white mb-6" data-testid="sender-profile-card">
      <button
        data-testid="sender-profile-toggle"
        onClick={() => setOpen((v) => !v)}
        className="w-full flex items-center justify-between p-3 text-left hover:bg-black/[0.02] transition-colors duration-150"
      >
        <div className="flex items-center gap-2">
          <div className="w-6 h-6 bg-[#0A0A0A] text-[#D4FF00] flex items-center justify-center">
            <User size={12} weight="bold" />
          </div>
          <div>
            <div className="text-[10px] tracking-[0.25em] uppercase text-[#525252]" style={{ fontFamily: "'Chivo', sans-serif", fontWeight: 700 }}>
              SENDER PROFILE
            </div>
            <div className="text-sm" style={{ fontFamily: "'Chivo', sans-serif", fontWeight: 700 }}>
              {complete ? (
                <>
                  {profile.name} · <span className="text-[#525252]">{profile.email}</span> · <span className="text-[#0047FF]">€{profile.price_per_lead}/lead</span>
                </>
              ) : (
                <span className="text-red-600">Not set — click to add your name + email</span>
              )}
            </div>
          </div>
        </div>
        {open ? <CaretUp size={14} weight="bold" /> : <CaretDown size={14} weight="bold" />}
      </button>

      {open && (
        <form onSubmit={submit} className="p-4 border-t border-black/10 grid grid-cols-1 sm:grid-cols-2 gap-3">
          <label className="block">
            <div className="text-[10px] tracking-[0.2em] uppercase text-[#525252] mb-1" style={{ fontFamily: "'Chivo', sans-serif", fontWeight: 700 }}>Your Name *</div>
            <input
              data-testid="sender-name-input"
              required
              value={form.name}
              onChange={(e) => setForm({ ...form, name: e.target.value })}
              className="w-full border border-black/25 px-3 py-2 text-sm outline-none focus:border-black"
              placeholder="Jane Doe"
            />
          </label>
          <label className="block">
            <div className="text-[10px] tracking-[0.2em] uppercase text-[#525252] mb-1" style={{ fontFamily: "'Chivo', sans-serif", fontWeight: 700 }}>Your Email *</div>
            <input
              data-testid="sender-email-input"
              required
              type="email"
              value={form.email}
              onChange={(e) => setForm({ ...form, email: e.target.value })}
              className="w-full border border-black/25 px-3 py-2 text-sm outline-none focus:border-black"
              placeholder="jane@yourdomain.com"
              style={{ fontFamily: "'IBM Plex Mono', monospace" }}
            />
          </label>
          <label className="block">
            <div className="text-[10px] tracking-[0.2em] uppercase text-[#525252] mb-1" style={{ fontFamily: "'Chivo', sans-serif", fontWeight: 700 }}>Company (optional)</div>
            <input
              data-testid="sender-company-input"
              value={form.company}
              onChange={(e) => setForm({ ...form, company: e.target.value })}
              className="w-full border border-black/25 px-3 py-2 text-sm outline-none focus:border-black"
              placeholder="Helios Leads"
            />
          </label>
          <label className="block">
            <div className="text-[10px] tracking-[0.2em] uppercase text-[#525252] mb-1" style={{ fontFamily: "'Chivo', sans-serif", fontWeight: 700 }}>Price € per lead</div>
            <select
              data-testid="sender-price-input"
              value={form.price_per_lead}
              onChange={(e) => setForm({ ...form, price_per_lead: e.target.value })}
              className="w-full border border-black/25 px-3 py-2 text-sm outline-none focus:border-black bg-white"
            >
              <option value="0.50">€0.50 / lead — bulk (500+ leads, company-level)</option>
              <option value="0.80">€0.80 / lead — standard (100-500 leads)</option>
              <option value="1">€1 / lead — small batch (under 100 leads)</option>
              <option value="2">€2 / lead — verified emails via Hunter</option>
              <option value="5">€5 / lead — named decision-maker + phone</option>
              <option value="49-mo">€49 / month — country subscription (recurring)</option>
            </select>
          </label>
          <div className="sm:col-span-2 flex gap-2">
            <button
              type="submit"
              data-testid="sender-profile-save"
              className="bg-[#0047FF] text-white px-4 py-2 text-xs tracking-[0.2em] uppercase shadow-[2px_2px_0px_#0A0A0A] hover:bg-[#0038CC] active:translate-y-[2px] active:translate-x-[2px] active:shadow-none transition-colors duration-150"
              style={{ fontFamily: "'Chivo', sans-serif", fontWeight: 700 }}
            >
              SAVE PROFILE
            </button>
          </div>
        </form>
      )}
    </div>
  );
};
